import { useMutation } from '@tanstack/react-query';
import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useFetch } from '@/hooks/useFetch';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import type { ErrorResponse } from '@/types/apiTypes';
import type { ShareClientRequest, ShareClientResponse } from '@/types/clientDetailsApiTypes';

interface ShareClientMutationPayload {
  data: ShareClientRequest;
  clientId?: number | string | null;
}

export const useShareClient = () => {
  const { doFetch: shareClient } = useFetch<ShareClientRequest, ShareClientResponse>();
  const [searchQuery] = useSearchQuery();
  const clientId = searchQuery.get(CLIENT_ID_QUERY_KEY);

  return useMutation<ShareClientResponse, ErrorResponse<unknown>, ShareClientMutationPayload>({
    mutationFn: ({ data, clientId: clientIdParam }: ShareClientMutationPayload) =>
      shareClient(`/api/clients/${clientIdParam ?? clientId}/update/data`, {
        method: 'POST',
        body: data,
      }),
  });
};
